/* Accepted inquiries only. GA4 is top-frame; Meta uses Shopify's consent-managed custom pixel. */
(function () {
  'use strict';
  if (window.BuonCiboLeadMeasurement) return;

  var KEY = 'bc:lead:pending:v1';
  var TTL = 30 * 60 * 1000;
  var TYPES = {
    'general-contact': { form: 'contact_message', program: 'general_contact' },
    'catering-request': { form: 'catering_request', program: 'catering' },
    'private-room-request': { form: 'private_room_request', program: 'private_room' },
    'event-inquiry': { form: 'event_inquiry', program: 'other_events' }
  };
  var PATHS = ['/', '/contact', '/pages/contact', '/pages/catering', '/pages/private-room', '/pages/wine-events', '/pages/charcuterie'];
  var META_ENDPOINT = 'https://buon-cibo-reporting-portal.vercel.app/api/tracking/meta/leads';
  var timer = null;
  var attempts = 0;
  var loadingPrivacy = false;

  function clear() {
    try { window.sessionStorage.removeItem(KEY); } catch (_) {}
  }

  function permissions() {
    if (navigator.globalPrivacyControl === true) return { analytics: false, marketing: false };
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return null;
    try {
      return {
        analytics: privacy.analyticsProcessingAllowed() === true,
        marketing: privacy.marketingAllowed() === true && privacy.saleOfDataAllowed() === true
      };
    } catch (_) { return null; }
  }

  function read() {
    try {
      var record = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
      if (!record) return null;
      var age = Date.now() - record.created_at;
      if (record.version !== 1 || !TYPES[record.kind] || !/^bc_lead_[a-f0-9-]{32,36}$/.test(record.event_id) ||
          !Number.isFinite(record.created_at) || age < 0 || age > TTL ||
          !/^#(?:contact_form|BcContact-[A-Za-z0-9_-]+|BcCateringCallback|catering-request)$/.test(record.return_hash) ||
          (record.source_path !== '' && PATHS.indexOf(record.source_path) === -1) ||
          typeof record.analytics !== 'boolean' || typeof record.marketing !== 'boolean' ||
          ['pending', 'claimed', 'complete'].indexOf(record.state) === -1) {
        clear();
        return null;
      }
      // Legacy already-claimed attempts must not replay after this module is upgraded.
      if (!record.destinations) record.destinations = {
        ga4: record.state === 'pending' ? 'pending' : 'complete',
        shopify: record.state === 'pending' ? 'pending' : 'complete'
      };
      if (['pending', 'claimed', 'complete', 'skipped'].indexOf(record.destinations.ga4) === -1 ||
          ['pending', 'claimed', 'complete', 'skipped'].indexOf(record.destinations.shopify) === -1) {
        clear(); return null;
      }
      if (!record.destinations.meta) record.destinations.meta = record.state === 'pending' ? 'pending' : 'skipped';
      if (['pending', 'claimed', 'complete', 'skipped'].indexOf(record.destinations.meta) === -1) { clear(); return null; }
      if (record.destinations.meta === 'claimed' && Date.now() - Number(record.meta_claimed_at || 0) > 15000) record.destinations.meta = 'pending';
      return record;
    } catch (_) { clear(); return null; }
  }

  function write(record) {
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify(record));
      return window.sessionStorage.getItem(KEY) === JSON.stringify(record);
    } catch (_) { return false; }
  }

  function randomId() {
    if (!window.crypto) return null;
    if (typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    if (typeof window.crypto.getRandomValues !== 'function') return null;
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, function (byte) { return byte.toString(16).padStart(2, '0'); }).join('');
  }

  function begin(kind, returnHash) {
    try {
      var granted = permissions();
      if (!TYPES[kind] || !granted || (!granted.analytics && !granted.marketing) || window.Shopify.designMode) {
        clear();
        return null;
      }
      var hash = returnHash || '#contact_form';
      if (!/^#(?:contact_form|BcContact-[A-Za-z0-9_-]+|BcCateringCallback|catering-request)$/.test(hash)) return null;
      var path = PATHS.indexOf(window.location.pathname) !== -1 ? window.location.pathname : '';
      var previous = read();
      // Captcha resubmission and repeated clicks share the original attempt's ID.
      if (previous && previous.state === 'pending' && previous.destinations.ga4 === 'pending' && previous.destinations.shopify === 'pending' && previous.kind === kind && previous.source_path === path && previous.return_hash === hash) {
        previous.analytics = previous.analytics && granted.analytics;
        previous.marketing = previous.marketing && granted.marketing;
        return write(previous) ? previous.event_id : null;
      }
      var id = randomId();
      if (!id) return null;
      var record = {
        version: 1, event_id: 'bc_lead_' + id, state: 'pending', kind: kind,
        source_path: path, return_hash: hash, created_at: Date.now(),
        analytics: granted.analytics, marketing: granted.marketing
      };
      return write(record) ? record.event_id : null;
    } catch (_) { return null; }
  }

  function retry() {
    if (timer !== null || attempts >= 720) return;
    attempts += 1;
    timer = window.setTimeout(function () { timer = null; complete(); }, 250);
  }

  function complete() {
    var record = read();
    if (!record || record.state !== 'pending') return;
    var granted = permissions();
    if (granted && !((record.analytics && granted.analytics) || (record.marketing && granted.marketing))) {
      clear();
      return;
    }
    // A signup, direct URL, stale success page, or another form must never count as this inquiry.
    if (window.location.hash !== record.return_hash) return;
    if (document.querySelector('[data-bc-lead-error]')) { clear(); return; }
    if (!document.querySelector('[data-bc-lead-success]')) return;
    if (!granted) { loadPrivacy(); retry(); return; }
    if (!record.confirmed_at) { record.confirmed_at = Math.floor(Date.now() / 1000); if (!write(record)) return; }
    var type = TYPES[record.kind];
    var payload = {
      schema_version: 1,
      event_id: record.event_id,
      form_id: type.form,
      program: type.program,
      lead_type: 'inquiry',
      source_path: record.source_path,
      success_path: window.location.pathname,
      analytics_consent_at_submit: record.analytics && granted.analytics,
      marketing_consent_at_submit: record.marketing && granted.marketing
    };
    function settled(destination, accepted) {
      var current = read();
      if (!current || current.event_id !== record.event_id || current.destinations[destination] !== 'claimed') return;
      current.destinations[destination] = accepted === false ? 'pending' : 'complete';
      current.state = ['ga4', 'shopify', 'meta'].every(function (key) { return ['complete', 'skipped'].indexOf(current.destinations[key]) !== -1; }) ? 'complete' : 'pending';
      write(current);
      if (accepted === false) retry();
    }
    function claim(destination) {
      var current = read();
      if (!current || current.event_id !== record.event_id || current.destinations[destination] !== 'pending') return false;
      current.destinations[destination] = 'claimed';
      if (destination === 'meta') current.meta_claimed_at = Date.now();
      return write(current);
    }
    function matchingCookie(name) {
      try {
        var match = document.cookie.split(';').map(function (part) { return part.trim(); }).find(function (part) { return part.indexOf(name + '=') === 0; });
        var value = match ? decodeURIComponent(match.slice(name.length + 1)) : '';
        return value.length <= 550 && /^fb\.\d{1,2}\.\d{10,13}\.[A-Za-z0-9._-]{1,512}$/.test(value) ? value : '';
      } catch (_) { return ''; }
    }
    var metaSupported = record.kind === 'catering-request' || record.kind === 'private-room-request';
    if (metaSupported && record.destinations.meta === 'claimed') retry();
    if ((!metaSupported || !payload.marketing_consent_at_submit) && record.destinations.meta === 'pending') {
      var skipped = read();
      if (skipped && skipped.event_id === record.event_id) { skipped.destinations.meta = 'skipped'; write(skipped); }
    } else if (metaSupported && record.destinations.meta === 'pending') {
      if (Date.now() < Number(record.next_meta_at || 0)) retry();
      else if (claim('meta')) {
        var metaClaimedAt = read().meta_claimed_at;
        retry();
        var capiPayload = {
          schema_version: 1, event_id: record.event_id, form_id: type.form, program: type.program,
          lead_type: 'inquiry', source_path: record.source_path, success_path: window.location.pathname,
          event_time: record.confirmed_at, marketing_consent_at_submit: true, marketing_consent_now: true
        };
        var fbp = matchingCookie('_fbp'), fbc = matchingCookie('_fbc');
        if (fbp) capiPayload.fbp = fbp;
        if (fbc) capiPayload.fbc = fbc;
        function metaResult(accepted, terminal) {
          var current = read();
          if (!current || current.event_id !== record.event_id || current.destinations.meta !== 'claimed' || current.meta_claimed_at !== metaClaimedAt) return;
          current.meta_attempts = Number(current.meta_attempts || 0) + 1;
          current.next_meta_at = Date.now() + Math.min(8000, 1000 * Math.pow(2, current.meta_attempts));
          if (!write(current)) return;
          settled('meta', accepted || terminal);
        }
        var permitted = permissions();
        if (!permitted || !permitted.marketing || !record.marketing) metaResult(false, true);
        else {
          try {
            window.fetch(META_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(capiPayload), mode: 'cors', credentials: 'omit', cache: 'no-store',
              referrerPolicy: 'no-referrer', keepalive: true,
              signal: window.AbortSignal && window.AbortSignal.timeout ? window.AbortSignal.timeout(12000) : undefined
            }).then(function (response) {
              return response.json().then(function (result) {
                metaResult(response.ok && result.ok === true && result.status === 'submitted',
                  [400, 403, 409, 410, 415].indexOf(response.status) !== -1);
              });
            }).catch(function () { metaResult(false, false); });
          } catch (_) { metaResult(false, false); }
        }
      }
    }
    record = read();
    if (!record) return;
    // Independent destination claims: a blocked/rejected Shopify publisher cannot lose or repeat GA4.
    if (!payload.analytics_consent_at_submit && record.destinations.ga4 === 'pending') {
      record.destinations.ga4 = 'skipped';
      if (!write(record)) return;
    } else if (record.destinations.ga4 === 'pending') {
      var ga = window.BuonCiboAnalytics;
      if (ga && typeof ga.lead === 'function' && claim('ga4')) {
        try { settled('ga4', ga.lead(payload)); } catch (_) { settled('ga4', false); }
      } else retry();
    }
    var publish = window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish;
    if (record.destinations.shopify === 'pending') {
      if (typeof publish !== 'function') { retry(); return; }
      if (!claim('shopify')) return;
      try {
        Promise.resolve(publish.call(window.Shopify.analytics, 'bc:lead_submitted', payload)).then(function (accepted) { settled('shopify', accepted); }, function () { settled('shopify', false); });
      } catch (_) { settled('shopify', false); }
    }
  }

  function loadPrivacy() {
    if (permissions() || loadingPrivacy) return;
    var shopify = window.Shopify;
    if (!shopify || typeof shopify.loadFeatures !== 'function') return;
    loadingPrivacy = true;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        loadingPrivacy = false;
        if (!error) complete();
      });
    } catch (_) { loadingPrivacy = false; }
  }

  window.BuonCiboLeadMeasurement = Object.freeze({ begin: begin });

  // Native contact form only. Dynamic forms call begin explicitly before native .submit().
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var scope = form && form.closest ? form.closest('[data-bc-lead-kind]') : null;
    var kind = scope && scope.getAttribute('data-bc-lead-kind');
    if (!scope || !TYPES[kind] || !form.querySelector('input[name="form_type"][value="contact"]')) return;
    if (!form.checkValidity()) { clear(); return; }
    var topic = form.querySelector('select[name="contact[Topic]"]');
    if (topic && topic.value === 'Catering') kind = 'catering-request';
    if (topic && topic.value === 'An event') kind = 'event-inquiry';
    var returnField = form.querySelector('input[name="return_to"]');
    var returnTarget = returnField && returnField.value ? returnField.value : form.action;
    try { begin(kind, new URL(returnTarget, window.location.origin).hash); } catch (_) {}
  }, true);

  document.addEventListener('visitorConsentCollected', function () {
    var granted = permissions();
    var record = read();
    if (record && granted) {
      // An opt-in later in the same attempt must not restore a previously denied purpose.
      record.analytics = record.analytics && granted.analytics;
      record.marketing = record.marketing && granted.marketing;
      if (!record.analytics && !record.marketing) clear();
      else write(record);
    }
    complete();
  });

  function ready() { loadPrivacy(); complete(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  window.addEventListener('pageshow', ready);
})();
